import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { theme, createStandaloneToast } from '@frontend/components';

import { receiveProcessClasses } from 'modules/opDefs/data/actions';

import API from 'services/api';
import service from 'services/opDefService';

import * as sessionSelectors from 'store/session/selectors';

import { getErrorMessage } from 'utils/stringUtils';

import { createOpDef, init, types } from './actions';

const { toast } = createStandaloneToast({ theme });

export default function* root() {
  yield takeLatest(types.CREATE_REQUEST, watchCreate);
}

export function* initOpDefListPage() {
  const groupId = yield select(sessionSelectors.getGroupId);
  const [opDefs, processClasses] = yield all([
    call(service.listOpDefs, groupId),
    call(API.general.processClasses),
  ]);

  yield put(receiveProcessClasses({ processClasses }));
  yield put(init({ opDefs }));
}

function* watchCreate(action) {
  try {
    const groupId = yield select(sessionSelectors.getGroupId);
    const response = yield call(service.createOpDef, groupId, action.payload);
    yield put(createOpDef.success({ opDef: response }));
  } catch (error) {
    yield put(createOpDef.error());
    yield call(toast, {
      title: 'Error',
      status: 'error',
      description: getErrorMessage(error),
    });
  }
}
